import axios from 'axios';

export const enum LOG_EVENT {
  VISIT = 'VISIT',
  GAME_START = 'GAME_START',
  GAME_OVER = 'GAME_OVER',
  GAME_CLEAR = 'GAME_CLEAR',
  REPLAY = 'REPLAY',
  GO_TO_HOME = 'GO_TO_HOME',
  COPY_SHARE = 'COPY_SHARE',
  REDIRECT_INSTAGRAM = 'REDIRECT_INSTAGRAM',
  AD = 'AD',
  CREATE_ROOM = 'CREATE_ROOM',
  JOIN_ROOM = 'JOIN_ROOM',
  JOIN_SUCCESS = 'JOIN_SUCCESS',
  JOIN_FAIL = 'JOIN_FAIL',
}

export const enum LOG_SCENE {
  MAIN_SCENE = 'MAIN_SCENE',
  SHARE_SCENE = 'SHARE_SCENE',
  INTRO_SCENE = 'INTRO_SCENE',
  DRAWING_GAME_SCENE = 'DRAWING_GAME_SCENE',
  BRIDGE_SCENE_1 = 'BRIDGE_SCENE_1',
  RUNNING_GAME_SCENE = 'RUNNING_GAME_SCENE',
  BRIDGE_SCENE_2 = 'BRIDGE_SCENE_2',
  JUMPING_GAME_SCENE = 'JUMPING_GAME_SCENE',
  BRIDGE_SCENE_3 = 'BRIDGE_SCENE_3',
  FINAL_GAME_SCENE = 'FINAL_GAME_SCENE',
  OUTRO_SCENE = 'OUTRO_SCENE',
  COOKIE_SCENE = 'COOKIE_SCENE',
  ALL_CLEAR_SCENE = 'ALL_CLEAR_SCENE',
  MULTIPLAY_SCENE = 'MULTIPLAY_SCENE',
}

const DEBOUNCE_DT = 200;
let lastLogDT: number = Date.now();

export function logging(event: LOG_EVENT, scene: LOG_SCENE, user: string, userAgent: string): void {
  if (Date.now() - lastLogDT >= DEBOUNCE_DT) {
    lastLogDT = Date.now();
    axios.post('https://ninimo.thepinkfong.com/api/logs', {
      data: {
        event,
        scene,
        user,
        userAgent,
      },
    });
  }
}
